(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('teamOrdersTable', function ($Orders, $uibModal, $timeout, uiGridConstants, uiGridGroupingConstants) {
		return {
			scope: {
				storeId: '='
			},
			templateUrl: 'directives/externalStore/teamOrdersTable.html',
			controller: function($scope) {

                $scope.init = function () {

                    $scope.gridOptions = {
                        columnDefs: [
                            {
                                field: 'orderedBy',
                                displayName: 'Ordered By',
                                width: "*"
                            },
                            {
                                field: 'orderedFor',
                                displayName: 'Ordered For',
                                width: "*"
                            },
                            {
                                field: 'productName',
                                displayName: 'Product Name',
                                width: "*"
                            },
                            {
                                field: 'inPackage',
                                displayName: 'In Package',
                                width: "*"
                            },
                            {
                                field: 'sizes',
                                displayName: 'Size',
                                width: "*"
                            },
                            {
                                field: 'color',
                                displayName: 'Color',
                                width: "*"
                            },
                            {
                                field: 'options',
                                displayName: 'Options',
                                width: "*"
                            },
                            {
                                field: 'inseam',
                                displayName: 'Inseam',
                                width: "*"
                            },
                            {
                                field: 'fit',
                                displayName: 'Fit',
                                width: "*"
                            },
                            {
                                field: 'customName',
                                displayName: 'Custom Name',
                                width: "*"
                            },
                            {
                                field: 'customNumber',
                                displayName: 'Custom Number',
                                width: "*"
                            },
                            {
                                field: 'quantity',
                                displayName: 'Quantity',
                                width: "*"
                            },
                            {
                                field: 'orderID',
                                displayName: 'Order ID',
                                width: "*"
                            },
                            {
                                field: 'created',
                                displayName: 'Created',
                                width: "*"
                            },
                        ],
                        enableSorting: true,
                        enableColumnResizing: true,
                        enableFiltering: true,
                        showGridFooter: true,
                        showColumnFooter: true,
                        fastWatch: true,
                        enableGridMenu: true,
                        enableSelectAll: true,
                        exporterCsvFilename: 'myteam.csv',
                        exporterMenuPdf: false,
                        exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
                        onRegisterApi: function(gridApi){
                          $scope.gridApi = gridApi;
                          $scope.gridApi.core.addRowHeaderColumn( { name: 'rowHeaderCol', displayName: '', width: 30, cellTemplate: '<div class="ui-grid-cell-contents"><a class="grid-anchor" ng-click="grid.appScope.selectOrder(row.entity)"><i class="fa fa-search"></i></a></div>' } );


                        },
                    };


                    $Orders.getTeamOrderedProducts($scope.storeId).then( (products) => {

                        $scope.gridOptions.data = products;
                    });

                };

                $scope.init();

			}
		};
	});

})();
